function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 512,
    rx: 64,
    ry: 64,
    style: {
      fill: "#3b5998",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    width: 512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.968 456V273.538h61.244l9.17-71.103h-70.413V157.04c0-20.588 5.72-34.62 35.235-34.62l37.656-.01V58.807C353.35 57.934 331.003 56 304.992 56c-54.288 0-91.45 33.146-91.45 93.998v52.437H152.14v71.103h61.4V456h73.428z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIconFacebook;